{
  "move": {
    "KeyW": "up",
    "ArrowUp": "up",
    "Space": "up",
    "KeyS": "down",
    "ArrowDown": "down",
    "KeyA": "left",
    "ArrowLeft": "left",
    "KeyD": "right",
    "ArrowRight": "right"
  },
  "actions": {
    "console": "Backquote",
    "sayAll": "KeyT",
    "sayTeam": "KeyY",
    "scores": "Tab",
    "interact": "KeyE",
    "jet": "KeyZ",
    "settings": "Escape",
    "inventory": "KeyI",
    "blockWheel": "KeyC"
  }
}
